import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../../../../src/app/Services/api.service';
import { StorageService } from '../../../../../src/app/Services/storage.service';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Label } from 'ng2-charts';
import * as Highcharts from '../../../../assets/js/highcharts';
import { totalmem } from 'os';


@Component({
    selector: 'app-master-dashboard',
    templateUrl: './master-dashboard.component.html',
    styleUrls: ['./master-dashboard.component.css']
})
export class MasterDashboardComponent implements OnInit {

    constructor(public storage: StorageService,
        public api: ApiService,
        public router: Router) {
        this.userType = this.storage.get('userType');
    }
    userType: any;
    orgDetails: any;
    public orgCountData:any = {};
    public tableShow: boolean = false;
    public tableBtnShow:boolean = false;
    public tableBtnData:any = [];
    public tableData: any = [];
    public sltdMonth:any;
    public organizationData: any = {
        activeOrg: 0,
        inactiveOrg: 0,
        totalOrg: 0,
        vehicle: 0,
        driver: 0,
        employee: 0,
        employeeApp: 0,
        driverApp: 0,
    }

    // vehicle: 0,
    //                 driver : 0,
    //                 employee: 0,
    //                 employeeApp: 0,
    //                 driverApp: 0,
    //                 costOfEmp:100,
    //                 costOfDri:100,
    //                 totCost:0,
    public tableCols = [
        { key: '#', display: '#' },
        {
            key: 'orgName', display: 'Organization Name', config: {
                isTruncate: true, truncateData: {
                    limit: 40,
                    concatVal: '...',
                }
            }
        },
        { key: 'vehicle', display: '#Vehicle' },
        { key: 'employee', display: '#Employee' },
        { key: 'driver', display: '#Driver' },
        { key: 'employeeApp', display: 'Employee App' },
        { key: 'driverApp', display: 'Driver App' },
        { key: 'costOfEmp', display: 'Cost of Employee App' },
        { key: 'costOfDri', display: 'Cost of Driver App' },
        {
            key: 'totEmpCost', display: 'Bill Amount for Employee App', config: {
                isCurrency: true,
                format: 'INR'
            }
        },
        { key: 'totDriCost', display: 'Bill Amount for Driver App',config:{
            isCurrency:true,
            format: 'INR'
        } },
        { key: 'totCost', display: 'Total Bill Amount',config:{
            isCurrency:true,
            format: 'INR'
        } },
        // {
        //   key: 'action',
        //   display: 'Action',
        //   config: {
        //     isAction: true,
        //     actions: [
        //       { display: 'Download Document', color: 'primary', icon: 'DownloadDocument' },
        //     ]
        //   }
        // }
    ];


    public chartStyles = {
        height: '37vh',
        width: '100%',
        //"max-height": "25vh",
    }

    public appInstallData = {};

    ngOnInit(): void {
        if (this.userType != 'maste-admin') {
            this.router.navigate(['/master/login']);
        }
        this.getOrgList();
        this.getAppInsData();
        this.processTableBtn();
        this.getOrgDataCount();
    }

    getLastMonths(n) {

        let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
          "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
    
        let today = new Date();
        let lastMonths = []
    
        for (let i = 0; i < n; i++) {
          let monthKey = today.getMonth() - i;
          let newDate = new Date(today.getTime());
          newDate.setMonth(monthKey);
          let monthStTs = new Date(newDate.getFullYear(), monthKey).getTime();
          let monthEndTs = new Date(newDate.getFullYear(), (monthKey + 1), 0, 23, 59, 59).getTime();
          lastMonths.push({
            name: monthNames[newDate.getMonth()] + ' - ' + newDate.getFullYear(),
            month: newDate.getMonth()+1,
            year: newDate.getFullYear(),
            startTs: monthStTs,
            endTs: monthEndTs,
          });
        }
        return lastMonths;
      }

    processTableBtn(){
        this.tableBtnData = this.getLastMonths(3).reverse();
        this.sltdMonth = this.tableBtnData[this.tableBtnData.length-1]['id'];
    }

    getOrgList() {
        this.organizationData = {
            ...this.organizationData,
            activeOrg: 0,
            inactiveOrg: 0,
            totalOrg: 0,
            vehicle: 0,
            driver: 0,
            employee: 0,
        };

        this.api.listOrg({})
            .then((res: any) => {
                // console.log('Success', res);
                if (res.status == 'success') {
                    if (res.data && res.data.length > 0) {
                        this.orgDetails = res.data.map((item) => {
                            let data = { ...item };
                            this.organizationData.totalOrg++;
                            // this.organizationData.employee += item.empCount ? item.empCount : 0;
                            // this.organizationData.vehicle += item.vehicleCount ? item.vehicleCount : 0;
                            // this.organizationData.driver += item.driversCount ? item.driversCount : 0;

                            return item
                        })
                        this.tableShow = true;
                    }
                }
            })
            .catch((error: any) => {
                console.log('Error', error);
            });

    }

    getAppInsData() {
        this.organizationData = {
            ...this.organizationData,
            employeeApp: 0,
            driverApp: 0,
        };
        this.api.masterOrgAppInsCount({}).then((res: any) => {
            this.organizationData.employeeApp = res && res.employee ? res.employee : 0;
            this.organizationData.driverApp = res && res.driver ? res.driver : 0;
        }).catch((err) => {
            console.log('err', err);
        })
    }

    getOrgDataCount() {
        this.tableData = [];
        this.tableShow = false;

        this.api.masterOrgDataCount({}).then(async (res: any) => {
            this.tableBtnShow = true;
            this.orgCountData = res;
            let lastMonth = new Date().getUTCMonth()+1;
            let curYear = new Date().getUTCFullYear();
            this.organizationData.employee += res && res.orgData && res.orgData.employee ? this.objCountValue(res.orgData.employee) : 0;
            this.organizationData.vehicle += res && res.orgData && res.orgData.vehicle ? this.objCountValue(res.orgData.vehicle) : 0;
            this.organizationData.driver += res && res.orgData && res.orgData.driver ? this.objCountValue(res.orgData.driver) : 0;

            let result: any = await this.processOrgCount(res,curYear,lastMonth).catch((err) => console.log(err));

            this.processChart();

            this.tableData = result;
            this.tableShow = true;
        }).catch((err) => {
            console.log('err', err);
        })
    }

    objCountValue(obj){
        let returnValue = 0;
        if(Object.keys(obj).length>0){
            Object.keys(obj).map((key:any)=>{
                if(obj[key]>0) returnValue+=obj[key];
            })
        }
        return returnValue;
    }
    async changeOrgTable(value){
        this.sltdMonth = value.id;
        this.tableShow = false;
        this.tableData = [];
        let result:any = await this.processOrgCount(this.orgCountData,value.year,value.month).catch((err)=>{ console.log(err)});
        this.tableData = result;
        this.tableShow = true;
    }

    processOrgCount(data,year,month) {
        return new Promise((res, rej) => {
            try {
                let returnData: any = [];
                if (data.orgInfo && Object.keys(data.orgInfo).length > 0)
                    Object.keys(data.orgInfo).map((org) => {
                        let item = {
                            orgName: data.orgInfo[org],
                            vehicle: data.orgData && data.orgData.vehicle && data.orgData.vehicle[org] ? data.orgData.vehicle[org] : 0,
                            driver: data.orgData && data.orgData.driver && data.orgData.driver[org] ? data.orgData.driver[org] : 0,
                            employee: data.orgData && data.orgData.employee && data.orgData.employee[org] ? data.orgData.employee[org] : 0,
                            employeeApp: 0,
                            driverApp: 0,
                            costOfEmp: 0,
                            costOfDri: 0,
                            totEmpCost: 0,
                            totDriCost: 0,
                            totCost: 0,
                        };
                       
                        if (data.appreport && data.appreport.driverApp && data.appreport.driverApp[org]) {
                            if (data.appreport.driverApp[org][year] && data.appreport.driverApp[org][year][month]) {
                                item.driverApp = data.appreport.driverApp[org][year][month];
                                item.costOfDri = 100;
                                item.totDriCost = item.driverApp * item.costOfDri;
                                item.totCost += item.totDriCost;
                            }
                        }
                        if (data.appreport && data.appreport.empApp && data.appreport.empApp[org]) {
                            if (data.appreport.empApp[org][year] && data.appreport.empApp[org][year][month]) {
                                item.employeeApp = data.appreport.empApp[org][year][month];
                                item.costOfEmp = 100;
                                item.totEmpCost = item.employeeApp * item.costOfEmp;
                                item.totCost += item.totEmpCost;
                            }
                        }
                        returnData.unshift(item);
                    })
                res(returnData);
            } catch (err) {
                console.log(err);
                rej(err);
            }
        })
    }


  processChart() {
    let data = {
      column: {
        emp: {
          value: [],

        },
        driver: {
          value: [],
        },
        average: {
          value: [],
        },
        xCategory: [],
      },
      pie: {
        total: 0,
        emp: 0,
        driver: 0,
      },
    };

    let months = this.getLastMonths(5);
    for (let m = 0; m < months.length; m++) {
      let obj = months[m];
      let empMonthVal:number = 0;
      let driverMonthVal:number = 0;
        
      if(this.orgCountData['appreport'] && this.orgCountData['appreport']['empApp']){
        Object.keys(this.orgCountData['appreport']['empApp']).map((org)=>{
            if(this.orgCountData['appreport']['empApp'][org] && this.orgCountData['appreport']['empApp'][org][obj['year']] &&  this.orgCountData['appreport']['empApp'][org][obj['year']][obj['month']]){
                empMonthVal += this.orgCountData['appreport']['empApp'][org][obj['year']][obj['month']];
            }
        });
      }
      if(this.orgCountData['appreport'] && this.orgCountData['appreport']['driverApp']){
        Object.keys(this.orgCountData['appreport']['driverApp']).map((org)=>{
            if(this.orgCountData['appreport']['driverApp'][org] && this.orgCountData['appreport']['driverApp'][org][obj['year']] && this.orgCountData['appreport']['driverApp'][org][obj['year']][obj['month']]){
                driverMonthVal += this.orgCountData['appreport']['driverApp'][org][obj['year']][obj['month']];
            }
        });
      }

      data.column.emp.value.unshift(empMonthVal);
      data.column.driver.value.unshift(driverMonthVal);
      data.column.average.value.unshift(Math.floor((empMonthVal + driverMonthVal) / 2));
      data.column.xCategory = [obj['name'], ...data.column.xCategory];

      data.pie.emp += empMonthVal;
      data.pie.driver += driverMonthVal;
      data.pie.total += empMonthVal + driverMonthVal;
    }
    this.loadChart(data);

  }

  loadChart(data: any) {
    this.appInstallData =  {
        chart: {
            marginTop: 25
        },
        title: {
            text: '',
            widthAdjust: -500
            // style: { 'margin-top':'10px'}
        },
        xAxis: {
            categories: data.column.xCategory
          },
        yAxis: {
            title: {
                text: 'Usage Count'
            }
        },
        legend: {
            align: 'right',
            verticalAlign: 'top',
            x: 0,
            y: -15,
            floating: true
        },
        labels: {
            items: [{
                html: 'Total App Usage',
                style: {
                    left: '40px',
                    top: '0px',
                    color: ( // theme 
                        Highcharts.defaultOptions.title.style &&
                        Highcharts.defaultOptions.title.style.color
                    ) || 'black'
                }
            }]
        },
        series: [{
            type: 'column',
            name: 'Driver App',
            data: data.column.driver.value,
            color: "#6462af"
            
        }, {
            type: 'column',
            name: 'Employee App',
            data: data.column.emp.value,
            color: "#4c7dfe"
        }, {
            type: 'pie',
            name: 'Total App Usage',
            data: [{
                name: 'Employee App',
                y: data.pie.emp,
                color: "#4c7dfe"
            }, {
                name: 'Driver App',
                y: data.pie.driver,
                color: '#6462af'//Highcharts.getOptions().colors[0]
            }],
            center: [70, 30],
            size: 60,
            showInLegend: false,
            dataLabels: {
                enabled: false
            }
        }]
    };
  }

}
